module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col col-lg-6"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('pos.profile.update-profile')))]), _c('profile')], 1)]), _c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col col-lg-6"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('pos.profile.change-password')))]), _c('password')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d1063dee"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/account/Account.vue
// module id = 2094
// module chunks = 1